import { render, staticRenderFns } from "./EnrolmentQuestionProgramEditor.vue?vue&type=template&id=1d687fbc&scoped=true"
import script from "./EnrolmentQuestionProgramEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionProgramEditor.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentQuestionProgramEditor.vue?vue&type=style&index=0&id=1d687fbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d687fbc",
  null
  
)

export default component.exports